import React, { useState, useEffect, useCallback } from 'react'
import { getUserDetails, findRole } from '../Utility/AsyncStorage';
import axios from "axios";
import { showToast } from './Toast';
import "../output.css"
import "../Styles/Modal.css"
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from 'react-tooltip'
// import Footer from './Footer';
import Loader from './Loader';

const UserTable = ({ data, assignUserDevice, handleEdit, handleActive, DeleteUser }) => {
  const userdetails = getUserDetails()

  const denyPermissionMap = {
    "REGIONAL ADMIN": ["SUPER ADMIN", "REGIONAL ADMIN", "SUB ADMIN"],
    "SUB ADMIN": ["SUPER ADMIN", "SUB ADMIN"],
    "ADMIN": ["SUPER ADMIN", "REGIONAL ADMIN", "SUB ADMIN", "ADMIN"]
  };

  const checkEditPermission = (company) => {
    const deniedRoles = denyPermissionMap[userdetails.role] || [];
    return !deniedRoles.includes(company.role);
  };

  return (
    <div className="p-2 w-full mx-auto " style={{ height: "fit-content", maxHeight: "75vh", overflowY: "scroll", scrollbarWidth: "thin" }}>
      <div className="overflow-hidden bg-white shadow-md rounded-xl table-scroll" >
        <table className="w-full border-collapse" >
          {/* Table Header */}
          <thead>
            <tr className="bg-gray-200 text-black text-sm capitalize border-b table-header-group">
              <th className="px-6 py-3 text-left ">S.no</th>
              {/* <th className="px-6 py-3 text-left ">User no</th> */}
              <th className="px-6 py-3 text-left">Name</th>
              <th className="px-6 py-3 text-left">Contact no</th>
              <th className="px-6 py-3 text-left">Role</th>
              <th className="px-6 py-3 text-left ">Company</th>
              <th className="px-6 py-3 text-left">Status</th>
              <th className="px-6 py-3 text-left">Action</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="text-gray-700 text-sm">
            {data.map((company, index) => (
              <tr
                key={index}
                className="border-b hover:bg-gray-50 transition  company-table-block"
              >
                <td className="px-6 py-3 text-pink-500 text-xs text-center"><span>sno</span>{index + 1}</td>
                {/* <td className="px-6 py-3 text-pink-500 font-medium text-center">{company.user_num}</td> */}
                <td className="px-6 py-3"><span>Nmae</span>{company.name}</td>
                <td className="px-6 py-3 "><span>Contact number</span>{company.phone}</td>
                <td className="px-6 py-3 "><span>Role</span>{findRole(company.role)}</td>
                <td className="px-6 py-3"><span>Company</span>{company.company_name}</td>
                <td className="px-6 py-3 text-center " style={{ opacity: (checkEditPermission(company) ? 1 : 0.2) }}
                  onClick={(e) => {
                    if (checkEditPermission(company)) {
                      e.stopPropagation(); // Prevent row click event
                      handleActive(company);
                    }
                  }}><span>Active Status</span>
                  <div style={{ width: 15, height: 15, backgroundColor: (company.is_active === "Y" ? "green" : "red"), borderRadius: "50%", alignItems: "center" }}></div>
                </td>

                <td className=" text-lg items-center text-center actionButtons" style={{ color: (checkEditPermission(company) ? "black" : 'gray'), opacity: (!((userdetails.role === "ADMIN" || userdetails.role === "REGIONAL ADMIN") && (company.role === "SUPER ADMIN" || company.role === "REGIONAL ADMIN")) ? 1 : 0.5) }}>
                  <i
                    className="fa fa-edit text-[15px]"
                    data-tooltip-id="my-tooltip" data-tooltip-content={checkEditPermission(company) ? "Edit" : "Disable"}
                    onClick={(e) => {
                      if (checkEditPermission(company)) {
                        e.stopPropagation(); // Prevent row click event
                        handleEdit(company);
                      }
                    }}
                  ></i>

                  <i
                    style={{ display: (company.role === "MACHINE INCHARGE" || company.role === "REGIONAL ADMIN" ? "inline" : "none"), marginLeft: 10 }}
                    className="fa fa-sitemap text-[15px]"
                    data-tooltip-id="my-tooltip1" data-tooltip-content={company.role === "MACHINE INCHARGE" ? "Assign Machine to User" : "Assign Company to User"}
                    onClick={(e) => {
                      if (company.role === "MACHINE INCHARGE" || (company.role === "REGIONAL ADMIN" && (userdetails.role === "SUPER ADMIN" || userdetails.role === "SUB ADMIN"))) {
                        e.stopPropagation(); // Prevent row click event
                        assignUserDevice(company);
                      }
                    }}
                  ></i>
                  {userdetails.role === "SUPER ADMIN" ?
                    <i style={{ marginLeft: 10 }}
                      className="fa fa-trash text-[15px]"
                      data-tooltip-id="my-tooltip1" data-tooltip-content={userdetails.role === "SUPER ADMIN" ? "Delete User" : "Disable"}
                      onClick={(e) => {
                        if (userdetails.role === "SUPER ADMIN") {
                          e.stopPropagation(); // Prevent row click event
                          DeleteUser(company);
                        }
                      }}
                    ></i> : <></>}

                  <Tooltip id="my-tooltip" />
                  <Tooltip id="my-tooltip1" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

function debounce(func, delay) {
  let timeoutId;

  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
}

function User() {
  const userdetails = getUserDetails()

  const [loaderState, setLoaderState] = useState(true);
  const [LoaderStateAssigned, setLoaderStateAssigned] = useState(true);
  // const compNum = useRef(userdetails.comp_num);
  // const [flag, setflag] = useState(true)

  const navigate = useNavigate();
  const [flagAssign, setflagAssign] = useState(false)
  const [allUserData, setAllUserData] = useState([])
  const [assignState, setAssignState] = useState(false)
  const [deviceList, setDeviceList] = useState([])
  const [deviceKey, setDeviceKey] = useState("")
  const [addUser, setAddUser] = useState(false)
  const [complist, setComplist] = useState([])
  const [userData, setUserData] = useState({
    phone: "",
    role: "",
    comp_num: ""
  })
  const [assignUserDetails, setAssignUserDetails] = useState({})
  const [selectedOption, setSelectedOption] = useState('');
  const options = [
    { value: "SUPER ADMIN", label: 'ITL SUPER ADMIN' },
    { value: "SUB ADMIN", label: 'ITL SUB ADMIN' },
    { value: "REGIONAL ADMIN", label: 'ITL REGIONAL ADMIN' },
    { value: "ADMIN", label: 'CUSTOMER ADMIN' },
    { value: "MACHINE INCHARGE", label: 'CUSTOMER MACHINE INCHARGE' },
  ];

  const [selectedUserStatus, setSelectedUserStatus] = useState('');
  const optionsUserStatus = [
    { id: "Y", label: 'Active' },
    { id: "N", label: 'Inactive' },
  ];
  const [selectedUserComp, setSelectedUserComp] = useState(userdetails.role === "ADMIN" ? userdetails.comp_num.toString() : '');
  const [companyOption, setCompanyOption] = useState([])
  const [deviceAssinedToUser, setDeviceAssignedToUser] = useState([])
  const [assignedCompany, setAssignedCompny] = useState([])
  const [compAssignOption, setCompAssignOption] = useState([])
  const [selectedAssincomp, setSelectedAssincomp] = useState("")

  const [isExpanded, setIsExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const handleIconClick = () => {
    setIsExpanded(true);
  };


  const handleChangeCompany = (e) => {
    setSelectedUserComp(e.target.value);
    // getUserList()
  };

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
    // getUserList()
  };
  const handleChangeUserStatus = (e) => {
    setSelectedUserStatus(e.target.value);
    // getUserList()
  };

  const handleUserChange = (fieldName, value) => {
    setUserData((prevData) => ({
      ...prevData,
      [fieldName]: value, // Dynamically update based on field name
    }));
  };

  const getUserList = async (selectedOption, selectedUserStatus, selectedUserComp, searchTerm) => {

    // console.log("getUserList searchTerm", typeof (searchTerm), userdetails.role, selectedUserComp)

    let temp_selectedUserComp = selectedUserComp == "" ? undefined : selectedUserComp

    try {
      let url = "https://itlapi.flovation.in/user/listOfUser";
      let body = {
        role: selectedOption,
        is_active: selectedUserStatus,
        search: searchTerm ?? undefined,
        // comp_num: (selectedUserComp == undefined || selectedUserComp.length == 0) ? selectedUserComp : (userdetails.role === "REGIONAL ADMIN" ? userdetails.assigned_companies : undefined)
        comp_num: temp_selectedUserComp ?? (userdetails.role === "REGIONAL ADMIN" ? userdetails.assigned_companies : undefined)
      }

      // console.log("getUserList body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {
          setLoaderState(false)
          if (response.data.statusCode === 0) {
            console.log("getUserList", response.data.op)
            setAllUserData(response.data.op)

          }
          else {
            console.log("getUserList", response.data.msg)
            showToast(response.data.msg, 3000, "red");
            setAllUserData([])
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
          setAllUserData([])
        }

      }).catch(error => {
        console.log("getUserList", error)
        if (error.response.status === 403) {
          console.log("getUserList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("getUserList else", error)
        setAllUserData([])
      })
    } catch (error) {
      console.log("getUserList", error)
      setAllUserData([])
    }
  }
  const getDeviceList = async (item) => {
    try {
      setDeviceList([])

      console.log(item)
      let url = "https://itlapi.flovation.in/device/fetchDeviceTobeAssignedToUser";
      let body = {
        user_num: item.user_num,
        comp_num: item.comp_num
      }

      console.log("detdevice body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            console.log("getDeviceList", response.data.op)

            setDeviceList(response.data.op)

          }
          else {
            console.log("getDeviceList", response.data.msg)
            // showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("getDeviceList", error)
        if (error.response.status === 403) {
          console.log("getUserList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
      })
    } catch (error) {
      console.log("getDeviceList", error)
    }
  }

  const getCompanyList = async (item) => {
    try {
      setAssignedCompny([])
      let url = "https://itlapi.flovation.in/user/fetchAlreadyAssignedCompaniesToUser";
      let body = {
        user_num: item.user_num
      }

      console.log("getCompanyList body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          setLoaderStateAssigned(false)
          if (response.data.statusCode === 0) {
            console.log("getCompanyList", response.data.op)
            setAssignedCompny(response.data.op)

          }
          else {
            console.log("getCompanyList", response.data.msg)
            // showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("getCompanyList", error)
        if (error.response.status === 403) {
          console.log("getCompanyList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
      })
    } catch (error) {
      console.log("getCompanyList", error)
    }
  }


  const assignUserDevice = (item) => {
    setAssignState(true)
    setLoaderStateAssigned(true)
    setAssignUserDetails(item)
    if (item.role == "MACHINE INCHARGE") {
      getDeviceList(item)
      getAssignedDevice(item)
    }
    else {
      getCompanyList(item)
      getCompanytoAssign(item)
    }
  }

  const getAssignedDevice = async (item) => {
    console.log("items are", item)
    setDeviceAssignedToUser([])

    try {

      let url = "https://itlapi.flovation.in/user/fetchDeviceAssignedToUser";
      let body = {
        user_num: item.user_num
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {
          setLoaderStateAssigned(false)
          if (response.data.statusCode === 0) {
            console.log("setDeviceAssignedToUser", response.data.op)
            setDeviceAssignedToUser(response.data.op)

          }
          else {
            console.log("getUserList", response.data.msg)
            // showToast(response.data.msg, 3000, "red");

          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("getUserList", error)
        if (error.response.status === 403) {
          console.log("getUserList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("getUserList else", error)
      })
    } catch (error) {
      console.log("getUserList", error)
    }

  }

  const getCompanytoAssign = async (item) => {

    try {
      setCompAssignOption([])

      let url = "https://itlapi.flovation.in/user/fetchCompaniesToBeAssignToUser";
      let body = {
        user_num: item.user_num
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            console.log("getCompanytoAssign", response.data.op)
            setCompAssignOption(response.data.op)

          }
          else {
            console.log("getCompanytoAssign", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("getCompanytoAssign", error)
        if (error.response.status === 403) {
          console.log("getCompanytoAssign if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("getCompanytoAssign else", error)
      })
    } catch (error) {
      console.log("getCompanytoAssign", error)
    }

  }

  const handleEdit = (comp) => {
    setUserData(comp)
    setAddUser(true)
  }

  const handleActive = async (comp) => {
    try {

      let url = "https://itlapi.flovation.in/user/updateUserDetails";
      let body = {
        // phone: comp.phone,
        // role: comp.role,
        user_num: comp.user_num,
        name: comp.name,
        is_active: (comp.is_active === 'Y' ? "N" : "Y")
      }

      console.log("handleActive body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("handleActive", response.data.op)
            showToast(response.data.msg, 3000, "green");
            // setUserData([])
            // setAddUser(false)

            getUserList(selectedOption, selectedUserStatus, selectedUserComp, searchTerm)
          }
          else {
            console.log("handleActive", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }
        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("handleActive", error)
        if (error.response.status === 403) {
          console.log("handleActive if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("handleActive else", error)
      })
    } catch (error) {
      console.log("handleActive", error)
    }
  }

  const DeleteUser = async (comp) => {
    console.log("delete user detail", comp)
    try {

      let url = "https://itlapi.flovation.in/user/deleteUser";
      let body = {
        user_num: comp.user_num,
        delete_key: "SM"
      }

      console.log("DeleteUser body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            showToast(response.data.msg, 3000, "green");
            // getUserList()
            getUserList(selectedOption, selectedUserStatus, selectedUserComp, searchTerm)

          }
          else {
            console.log("DeleteUser", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }
        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("DeleteUser", error)
        if (error.response.status === 403) {
          console.log("DeleteUser if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("DeleteUser else", error)
      })
    } catch (error) {
      console.log("DeleteUser", error)
    }
  }

  const handleDeviceToUser = async () => {
    console.log("handleDeviceToUser", assignUserDetails)
    try {

      let url = "https://itlapi.flovation.in/user/assignUserDevice";
      let body = {
        user_num: assignUserDetails.user_num,
        device_ids: deviceKey,
        type: "1"
      }

      console.log("detdevice body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("handleDeviceToUser", response.data.op)

            showToast(response.data.msg, 3000, "green");
            setDeviceKey("")
            getDeviceList(assignUserDetails)
            getAssignedDevice(assignUserDetails)

          }
          else {
            console.log("handleDeviceToUser", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("handleDeviceToUser", error)
        if (error.response.status === 403) {
          console.log("handleDeviceToUser if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("handleDeviceToUser else", error)
      })
    } catch (error) {
      console.log("handleDeviceToUser", error)
    }
  }

  const submitNewUser = async () => {
    try {

      let url = "https://itlapi.flovation.in/user/addUser";
      let body = {
        name: userData.name,
        phone: userData.phone,
        role: userData.role,
        comp_num: (userdetails.role === "ADMIN" ? userdetails.comp_num : userData.comp_num)
      }

      console.log("submitNewUser body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("submitNewUser", response.data.op)

            getUserList(selectedOption, selectedUserStatus, selectedUserComp, searchTerm)
            showToast(response.data.msg, 3000, "green");
            setUserData([])
            setAddUser(false)
          }
          else {
            console.log("submitNewUser", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }
        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("submitNewUser", error)
        if (error.response.status === 403) {
          console.log("submitNewUser if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("submitNewUser else", error)
      })
    } catch (error) {
      console.log("submitNewUser", error)
    }
  }

  const updateUserDetails = async () => {
    try {

      let url = "https://itlapi.flovation.in/user/updateUserDetails";
      let body = {
        // phone: comp.phone,
        role: userData.role,
        user_num: userData.user_num,
        name: userData.name
      }

      console.log("updateUserDetails body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            console.log("handleActive")

            getUserList(selectedOption, selectedUserStatus, selectedUserComp, searchTerm)
            showToast(response.data.msg, 3000, "green");
            setUserData([])
            setAddUser(false)
          }
          else {
            console.log("handleActive", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }
        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("updateUserDetails", error)
        if (error.response.status === 403) {
          console.log("updateUserDetails if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("updateUserDetails else", error)
      })
    } catch (error) {
      console.log("updateUserDetails", error)
    }
  }

  const companiesList = async () => {
    try {

      let url = "https://itlapi.flovation.in/company/listOfCompany";
      let body = {
        comp_num: (userdetails.role === "REGIONAL ADMIN" ? userdetails.assigned_companies : undefined)
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("companiesList", response.data.op)
            setComplist(response.data.op)
            // setCompanyOption(response.data.op)
            const seen = new Set();
            const uniqueCompanies = response.data.op
              .filter((item) => {
                if (!seen.has(item.comp_num)) {
                  seen.add(item.comp_num);
                  return true;
                }
                return false;
              })
              .map((item) => ({
                id: item.comp_num,
                label: item.company_name,
              }))

            // console.log("Unique Companies:", uniqueCompanies);
            setCompanyOption(uniqueCompanies);

          }
          else {
            console.log("companiesList", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("companiesList", error)
        if (error.response.status === 403) {
          console.log("companiesList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("companiesList else", error)
      })
    } catch (error) {
      console.log("companiesList", error)
    }
  }

  const Deleteitem = async (item) => {
    console.log("delete item", item, assignUserDetails)
    try {
      var url = ""
      var body = {}

      if (assignUserDetails.role == "MACHINE INCHARGE") {

        url = "https://itlapi.flovation.in/user/assignUserDevice";
        body = {
          user_num: assignUserDetails.user_num,
          device_ids: item.device_id.toString(),
          type: "0"
        }
      }
      else {
        url = "https://itlapi.flovation.in/user/assignCompaniesToUser";
        body = {
          user_num: assignUserDetails.user_num,
          comp_nums: item.comp_num.toString(),
          type: "0",
        }
      }

      console.log("detdevice body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {

            // getAssignedDevice(assignUserDetails)
            showToast(response.data.msg, 3000, "green");

            if (assignUserDetails.role === "MACHINE INCHARGE") {
              getDeviceList(assignUserDetails)
              getAssignedDevice(assignUserDetails)
            }
            else {
              getCompanyList(assignUserDetails)
              getCompanytoAssign(assignUserDetails)
            }
            setDeviceKey("")
            // setAssignState(false)
            // setAssignUserDetails({})

          }
          else {
            console.log("handleDeviceToUser", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("handleDeviceToUser", error)
        if (error.response.status === 403) {
          console.log("handleDeviceToUser if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("handleDeviceToUser else", error)
      })
    } catch (error) {
      console.log("handleDeviceToUser", error)
    }
  }

  const handleCompanyToUser = async () => {
    console.log(selectedAssincomp)
    try {

      let url = "https://itlapi.flovation.in/user/assignCompaniesToUser";
      let body = {
        user_num: assignUserDetails.user_num,
        comp_nums: selectedAssincomp,
        type: "1",
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            showToast(response.data.msg, 3000, "green");
            getCompanyList(assignUserDetails)
            getCompanytoAssign(assignUserDetails)

          }
          else {
            console.log("handleCompanyToUser", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("handleCompanyToUser", error)
        if (error.response.status === 403) {
          console.log("handleCompanyToUser if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("handleCompanyToUser else", error)
      })
    } catch (error) {
      console.log("handleCompanyToUser", error)
    }
    setSelectedAssincomp(""); setflagAssign(false)
  }

  const debouncedSearch = useCallback(
    debounce((selectedOption, selectedUserStatus, selectedUserComp, searchTerm) => {
      // console.log("Searching for:", selectedOption, selectedUserStatus, selectedUserComp, searchTerm);
      // You can call your API here
      getUserList(selectedOption, selectedUserStatus, selectedUserComp, searchTerm)
    }, 500),
    [] // only create this once
  );

  useEffect(() => {
    debouncedSearch(selectedOption, selectedUserStatus, selectedUserComp, searchTerm);
  }, [selectedOption, selectedUserStatus, selectedUserComp, searchTerm]);

  useEffect(() => {
    getUserList(selectedOption, selectedUserStatus, selectedUserComp, searchTerm)
    companiesList()
  }, []);

  return (
    <div style={{ width: "98%", margin: "1%" }}>
      <div className='px-2 text-lg flex justify-between items-center client-block ' style={{ marginBottom: 10 }}>
        <h1 className="text-xl font-semibold">User Management</h1>
        <div className="flex items-center resetButton">
          <div className='flex items-center sm-icomBlock '>
            <div style={{ position: 'relative', height: 40 }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  border: '1px solid #9385e3',
                  borderRadius: 20,
                  padding: '5px 10px',
                  width: isExpanded ? 200 : 40,
                  transition: 'width 0.3s ease',
                  overflow: 'hidden',
                  backgroundColor: isExpanded ? 'white' : "#9385e3",
                  cursor: 'pointer'
                }}
                onMouseEnter={handleIconClick}
              ><i class="fa fa-search" style={{ color: isExpanded ? "#9385e3" : 'white' }}></i>

                {isExpanded && searchTerm === "" && (
                  <span className="search-place">Search...</span>
                )}
                <input
                  type="text"
                  // placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    marginLeft: 10,
                    border: 'none',
                    outline: 'none',
                    flex: 1,
                    opacity: isExpanded ? 1 : 0,
                    transition: 'opacity 0.3s ease',
                    backgroundColor: 'transparent'
                  }}
                />
              </div>
            </div>

            <div className='flex items-center hidden md-iconBlock'>
              <div className='px-3 py-1 bg-white borderradius-10 rounded-lg shadow-md border border-gray-300' style={{ margin: "0 5px" }}>
                <i class="fa fa-refresh" data-tooltip-id="my-tooltip1"
                  data-tooltip-content="Reset Filter"
                  onClick={() => {
                    setSelectedOption("");
                    setSelectedUserStatus("");
                    setSelectedUserComp(userdetails.role === "ADMIN" ? userdetails.comp_num.toString() : '');
                    setSearchTerm('');
                    setIsExpanded(false)
                  }}
                ></i>
              </div>

              <div className='px-3 py-1 bg-white borderradius-10 rounded-lg shadow-md border border-gray-300'>
                <i class="fa fa-plus" data-tooltip-id="my-tooltip"
                  data-tooltip-content="Add User" onClick={() => setAddUser(true)}></i>
                <Tooltip id="my-tooltip" /><Tooltip id="my-tooltip1" />
              </div>
            </div>

          </div>

          <div className='flex items-center'>
            <div className="relative w-full" style={{ margin: "0 10px" }}>
              <select
                value={selectedOption}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md   text-gray-700 bg-white appearance-none"
              >
                <option value="" disabled>Select Role</option>
                {options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="relative w-full" style={{ margin: "0 10px" }}>
              <select
                value={selectedUserStatus}
                onChange={handleChangeUserStatus}
                className="w-full p-2 border border-gray-300 rounded-md   text-gray-700 bg-white appearance-none"
              >
                <option value="" disabled>Select Status</option>
                {optionsUserStatus.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {userdetails.role == "ADMIN" ? <></> :
              <div className="relative w-full" style={{ margin: "0 10px" }}>
                <select
                  value={selectedUserComp}
                  onChange={handleChangeCompany}
                  className="w-full p-2 border border-gray-300 rounded-md   text-gray-700 bg-white appearance-none"
                >
                  <option value="" disabled>Select Company</option>
                  {companyOption.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            }
          </div>

          <div className='flex items-center xl-iconBlock '>
            <div className='px-3 py-1 bg-white borderradius-10 rounded-lg shadow-md border border-gray-300' style={{ margin: "0 5px" }}>
              <i class="fa fa-refresh" data-tooltip-id="my-tooltip1"
                data-tooltip-content="Reset Filter"
                onClick={() => {
                  setSelectedOption("");
                  setSelectedUserStatus("");
                  setSelectedUserComp(userdetails.role === "ADMIN" ? userdetails.comp_num.toString() : "");
                  setSearchTerm('');
                  setIsExpanded(false)
                }}
              ></i>
            </div>

            <div className='px-3 py-1 bg-white borderradius-10 rounded-lg shadow-md border border-gray-300' >
              <i class="fa fa-plus" data-tooltip-id="my-tooltip"
                data-tooltip-content="Add User" onClick={() => setAddUser(true)}></i>
              <Tooltip id="my-tooltip" /><Tooltip id="my-tooltip1" />
            </div>
          </div>

        </div>
      </div>



      {
        loaderState ? (
          <Loader />
        )
          :
          allUserData.length === 0 ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "76vh" }}>
              <img
                src={require("../Assets/no_data.png")}
                alt="No Data"
                style={{
                  borderRadius: 20,
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
          ) : (
            <UserTable data={allUserData} assignUserDevice={assignUserDevice} handleEdit={handleEdit} handleActive={handleActive} DeleteUser={DeleteUser} />
          )
      }

      {assignState && (
        <div className="overlay">
          <div className="form-box">
            <h2 className="text-xl font-bold mb-4 text-center">{assignUserDetails.role === "MACHINE INCHARGE"
              ? "Assigned Device to User"
              : "Assigned Company to User"}
            </h2>
            {assignUserDetails.role == "MACHINE INCHARGE" ?
              <div>
                {LoaderStateAssigned ?
                  <Loader />
                  :
                  <div>
                    {deviceAssinedToUser.length != 0 ?
                      <div>
                        {deviceAssinedToUser.map((item, index) => (
                          <div key={index}
                            className="flex items-center justify-between bg-gray-300 rounded-md p-2" style={{ margin: "5px 0" }}>
                            <h4>{item.device_name == null ? `Device${item.device_id}` : item.device_name}</h4>
                            <i
                              id='delete-icon'
                              className="fa fa-trash text-[15px]"
                              data-tooltip-id="my-tooltip1" data-tooltip-content="Delete"
                              onClick={(e) => {
                                e.target.classList.add("animate-shake");
                                setTimeout(() => {
                                  e.target.classList.remove("animate-shake");
                                }, 500); // Remove shake effect after 500ms
                                Deleteitem(item);
                              }}
                            ></i>
                            <Tooltip id="my-tooltip1" />
                          </div>
                        ))} </div> : <img style={{ justifySelf: "center" }}
                          src={require("../Assets/no_data.png")}
                          alt="logo"
                      />
                    }
                  </div>
                }

                <div style={{ width: "100%", margin: "20px 0", display: "inline-flex", flexDirection: "row", justifyContent: 'space-between', alignItems: 'center' }}>
                  <h1 className="text-xl font-bold text-center">Assign Additional Devices</h1>
                  <h2 onClick={() => setflagAssign(true)} style={{ backgroundColor: 'pink', padding: "1px 25px", fontSize: 20, borderRadius: 14, }}>
                    +
                  </h2>
                </div>

                {flagAssign ?
                  <div>
                    <div className="relative">
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Select Device
                      </label>
                      <select
                        id="deviceKey"
                        value={deviceKey}
                        onChange={(e) => setDeviceKey(e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500 bg-white"
                      >
                        <option value="">Select an option</option>
                        {deviceList.map((device) => (
                          <option key={device.device_id} value={device.device_id}>
                            {device.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end space-x-3 mt-4">
                      <button
                        onClick={() => { setAssignState(false); setDeviceKey(""); setAssignUserDetails({}); setflagAssign(false) }}
                        className="px-4 py-2 bg-gray-300 rounded-md"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleDeviceToUser}
                        className="px-4 py-2 bg-blue-500 text-white rounded-md"
                      >
                        Submit
                      </button>
                    </div>

                  </div>
                  :
                  <button
                    onClick={() => { setAssignState(false); setDeviceKey(""); setAssignUserDetails({}); setflagAssign(false) }}
                    className="w-full px-4  py-1 bg-gray-300 rounded-md text-right"
                  >
                    Cancel
                  </button>
                }
              </div>
              :
              <div>
                {LoaderStateAssigned ?
                  <Loader />
                  :
                  <div>
                    {assignedCompany.length ?
                      <div>
                        {assignedCompany.map((item, index) => (
                          <div key={index}
                            className="flex items-center justify-between bg-gray-300 rounded-md p-2" style={{ margin: "5px 0" }}>
                            <h4>{item.company_name}</h4>
                            <i
                              id='delete-icon'
                              className="fa fa-trash text-[15px]"
                              data-tooltip-id="my-tooltip1" data-tooltip-content="Delete"
                              onClick={(e) => {
                                e.target.classList.add("animate-shake");
                                setTimeout(() => {
                                  e.target.classList.remove("animate-shake");
                                }, 500); // Remove shake effect after 500ms
                                Deleteitem(item);
                              }}
                            ></i>
                            <Tooltip id="my-tooltip1" />
                          </div>
                        ))}

                      </div>
                      :
                      <img style={{ justifySelf: "center" }}
                        src={require("../Assets/no_data.png")}
                        alt="logo"
                      />
                    }
                  </div>
                }

                <div style={{ width: "100%", margin: "20px 0", display: "inline-flex", flexDirection: "row", justifyContent: 'space-between', alignItems: 'center' }}>
                  <h1 className="text-xl font-bold text-center">Assign Additional Companies</h1>
                  <h2 onClick={() => setflagAssign(true)} style={{ backgroundColor: 'pink', padding: "1px 25px", fontSize: 20, borderRadius: 14, }}>
                    +
                  </h2>
                </div>

                {flagAssign ?
                  <div>
                    <div className="relative">
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Select Company
                      </label>
                      <select
                        id="deviceKey"
                        value={selectedAssincomp}
                        onChange={(e) => setSelectedAssincomp(e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500 bg-white"
                      >
                        <option value="">Select an option</option>
                        {compAssignOption.map((device) => (
                          <option key={device.comp_num} value={device.comp_num}>
                            {device.company_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end space-x-3 mt-4">
                      <button
                        onClick={() => { setAssignState(false); setSelectedAssincomp(""); setAssignUserDetails({}); setflagAssign(false) }}
                        className="px-4 py-2 bg-gray-300 rounded-md"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleCompanyToUser}
                        className="px-4 py-2 bg-blue-500 text-white rounded-md"
                      >
                        Submit
                      </button>
                    </div>

                  </div>
                  :
                  <button
                    onClick={() => { setAssignState(false); setSelectedAssincomp(""); setAssignUserDetails({}); setflagAssign(false) }}
                    className="w-full px-4  py-1 bg-gray-300 rounded-md text-right"
                  >
                    Cancel
                  </button>
                }
              </div>
            }

          </div>
        </div>
      )}

      {addUser && (
        <div className="overlay">
          <div className="form-box">
            <h2 className="text-xl font-bold mb-4 text-center">{userData.user_num ? `Edit User` : `Add User`}</h2>

            {/* Input Fields */}
            <div className="space-y-4">

              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Name
                </label>
                <input
                  type="numeric"
                  id='name'
                  value={userData.name}
                  onChange={(e) => handleUserChange("name", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              {/* Contact Number */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Contact Number
                </label>
                <input
                  type="numeric"
                  id='phone'
                  // placeholder="WhatsApp Number"
                  value={userData.phone}
                  onChange={(e) => handleUserChange("phone", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                  readOnly={!!userData.user_num} // Correctly sets readOnly based on condition
                />
              </div>



              {/* {role_id} */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Select Role
                </label>
                <select
                  name="role"
                  id='role'
                  value={userData.role}
                  onChange={(e) => handleUserChange("role", e.target.value)}
                  className="w-full p-2 border rounded-md"
                >
                  <option value="">Select Role</option>
                  {userdetails.role == "SUPER ADMIN" && <option value="SUPER ADMIN">ITL SUPER ADMIN</option>}
                  {userdetails.role == "SUPER ADMIN" && <option value="REGIONAL ADMIN">ITL REGIONAL ADMIN</option>}
                  {userdetails.role == "SUPER ADMIN" && <option value="SUB ADMIN">ITL SUB ADMIN</option>}
                  <option value="ADMIN">CUSTOMER ADMIN</option>
                  <option value="MACHINE INCHARGE"> CUSTOMER MACHINE INCHARGE</option>
                </select>
              </div>

              {/* {comp_num} */}

              {
                userdetails.role == "ADMIN" ? <></> :

                  <div className="relative">
                    <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                      Select Company
                    </label>
                    <select
                      id="comp_num"
                      value={userData.comp_num}
                      onChange={(e) => handleUserChange("comp_num", e.target.value)}
                      className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500 bg-white"
                    >
                      <option value="">Select an option</option>
                      {complist.map((device) => (
                        <option key={device.comp_num} value={device.comp_num}>
                          {device.company_name}
                        </option>
                      ))}
                    </select>
                  </div>
              }

            </div>


            {/* Buttons */}
            <div className="flex justify-end space-x-3 mt-4">
              <button
                onClick={() => { setAddUser(false); setUserData([]) }}
                className="px-4 py-2 bg-gray-300 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={userData.user_num ? updateUserDetails : submitNewUser}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  )
}

export default User